var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"file",staticClass:"hp-uploadBtn1",staticStyle:{"visibility":"hidden"},attrs:{"id":"file","type":"file","multiple":_vm.multiple,"accept":_vm.accept},on:{"change":function($event){return _vm.handleClickUpload($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }